import { z } from 'zod';
import { KolSearchResultModel } from './kol';
const ICoordsSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
});
const StartingLocationSchema = z.union([
    z.object({
        type: z.literal('search'),
        id: z.string(),
        name: z.string(),
    }).extend(ICoordsSchema.shape),
    z.object({
        type: z.literal('browser'),
    }).extend(ICoordsSchema.shape),
    z.object({
        type: z.literal('hcp'),
        id: z.number(),
        name: z.string(),
    }).extend(ICoordsSchema.shape),
]);
const LocationInfoSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
    address: z.string().nullable(),
    kolId: z.number().nullable(),
});
const LocationRoutingLegSchema = z.object({
    start: LocationInfoSchema,
    end: LocationInfoSchema,
    distanceMiles: z.number(),
    durationSeconds: z.number(),
    meta: z.any(), // This could be more specific based on LocationProviderType
});
export const SmartRoutingSchema = z.object({
    status: z.enum(['select-location', 'submit-location', 'select-hcps', 'submit-route', 'route-generated']).nullable(),
    startingLocation: StartingLocationSchema.nullable(),
    selectedHcps: z.array(z.number()).nullable(),
    routingResult: z.object({
        legs: z.array(LocationRoutingLegSchema),
        provider: z.string(), // Adjust this based on LocationProviderType
    }).nullable(),
    searchIndex: z.string().nullable().optional(),
    hcpId: z.string().nullable().optional(),
    hideLocationForm: z.boolean().optional(),
    kolProfile: KolSearchResultModel.nullable().optional(),
});
